module.exports = __webpack_public_path__ + "static/c7-8a7e9fe2543c0784f61df48a483f092e.png";